<template>
  <ui-modal
    ref="messageModal"
    v-model="showDialog"
    :content-class="['message-dialog', rootMessageOptions.contentClass].filter(Boolean).join(' ')"
    :forcing="true"
    :header-title="rootMessageOptions.header || $t('block_user_title')"
    :hide-overlay="false"
    :close-icon="rootMessageOptions.useCloseIcon || false"
    @close-icon-event="closeByCloseIcon"
    @after-leave="onAfterLeave"
  >
    <v-sheet class="root-message-modal-container" max-width="440">
      <div :class="{ 'wd-pb-5': rootMessageOptions.icon }">{{ rootMessageOptions.message }}</div>
      <div v-if="rootMessageOptions.icon" class="wd-w-full wd-h-50 wd-mt-9">
        <FunNowSvgIcon max-width="100%" :image-path="rootMessageOptions.icon" />
      </div>
    </v-sheet>

    <template #buttons>
      <div class="event-buttons-group">
        <v-btn
          v-if="rootMessageOptions.showCancelBtn"
          class="cancel-btn mr-4 wd-bg-gray20"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="closeByCancel"
        >
          {{ rootMessageOptions.customCloseBtnText || $t('all_cancel') }}
        </v-btn>

        <v-btn
          class="confirm-btn text-white"
          type="submit"
          :color="'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="closeByConfirm"
        >
          {{ rootMessageOptions.customConfirmBtnText || $t('all_ok') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import UiModal from '@/components/dialog/ui-modal.vue'
import FunNowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

export default {
  name: 'RootMessageDialog',
  components: {
    UiModal,
    FunNowSvgIcon,
  },
  data() {
    return {}
  },
  computed: {
    showDialog: {
      get() {
        // FIXME: workaround to avoid showing `[nuxt] instance unavailable`
        if (this.rootMessageOptions?.message?.includes('instance unavailable')) {
          return false
        }
        return this.$store.getters['dialog/rootMessageDialog']
      },
      set(value) {
        this.$store.commit('dialog/SET_ROOT_MESSAGE_DIALOG', value)
      },
    },
    ...mapGetters({
      rootMessageOptions: 'dialog/rootMessageOptions',
    }),
  },
  methods: {
    closeByConfirm() {
      if (this.rootMessageOptions.confirm) {
        this.rootMessageOptions.confirm()
      }
      this.closeModal()
    },
    closeByCancel() {
      if (this.rootMessageOptions.cancel) {
        this.rootMessageOptions.cancel()
      }
      this.closeModal()
    },
    closeByCloseIcon() {
      if (this.rootMessageOptions.close) {
        this.rootMessageOptions.close()
      }
    },
    closeModal() {
      // by computed getter/setter to change store
      this.showDialog = false
    },
    onAfterLeave() {
      // clear data
      this.$store.dispatch('dialog/setRootMessageOption', { status: false, options: {} })
    },
  },
}
</script>

<style scoped lang="scss">
.root-message-modal-container {
  padding: 24px 20px;
  white-space: pre-line;
}
</style>
